enum CargoCompanyListingSortKey {
  COMPANY_NAME_ASC = "COMPANY_NAME_ASC",
  COMPANY_NAME_DESC = "COMPANY_NAME_DESC",
  COMPANY_DISPLAY_NAME_ASC = "COMPANY_DISPLAY_NAME_ASC",
  COMPANY_DISPLAY_NAME_DESC = "COMPANY_DISPLAY_NAME_DESC",
}

export default CargoCompanyListingSortKey;
